






















import { Component, Prop, Vue } from 'vue-property-decorator'
import AuthHeaderLayout from '@/components/layout/auth/AuthHeaderLayout.vue'
import AuthFooterLayout from '@/components/layout/auth/AuthFooterLayout.vue'

@Component({
    components: { AuthFooterLayout, AuthHeaderLayout },
})
export default class AuthEmptyLayout extends Vue {
    @Prop({ type: Boolean }) noMaxHeight!: boolean
}
